// react
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
// redux
import { Typography } from "@mui/material";
import { StyledLink } from "components/StyledUI";
// components
import { ROUTES } from "constants/routes";

const TermsHint: FC = () => {
  const { t } = useTranslation();
  return (
    <Typography>
      {t("cart.termsHint")}{" "}
      <StyledLink to={ROUTES.TERMS}>{t("cart.termsLink")}</StyledLink>{" "}
      {t("cart.termsHintEnd")}
    </Typography>
  );
};

export default TermsHint;
